import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BaseFormComponent } from '../base-form/base-form.component';
import { CustomFormControl, CustomFormControlDefinition } from '../../../shared/utils/custom-form-control';
import { Component, OnInit, inject } from '@angular/core';

@Component({
	selector: 'app-decline-request',
	templateUrl: './decline-request.component.html',
	styleUrls: ['./decline-request.component.scss']
})
export class DeclineRequestComponent extends BaseFormComponent implements OnInit {

	form: FormGroup;
	reason: CustomFormControlDefinition;
	numberOfCartons: CustomFormControlDefinition;
	showSuccess = false;
	context: string;
	modalCallback: any;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		public modal: NzModalRef,
		public fb: FormBuilder,
		public authService: AuthenticationService
	) {
		super(fb);
		this.reason = new CustomFormControl()
			.id('reason')
			.placeholder('Reason')
			.name('reason')
			.isRequired()
			.build();

		this.form = fb.group({
			reason: this.reason.formGroupControl
		});
	}

	ngOnInit(): void {
		this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.modalCallback = this.modal.componentInstance.callback;
		this.context = this.authService.getContextUser();
	}

	submitRequest() {
		if (!this.validateForm()) { return; }
		this.modalCallback(this.form.value);
	}

}
